module.exports = __webpack_public_path__ + "static/media/like_icon.96de10c4.svg";